/**
 * @ignore
 * Created by daletan on 6/22/16.
 */

'use strict';

const React = require('react');

const PropTypes = require('prop-types');

// Stores
const UserStore = require('../../global/stores/UserStore.es');
const PriceStore = require('../../global/stores/PriceStore.es.js');
const ItemStore = require('../../newPdp/stores/ItemStore.es');

// Components
const {
    PriceComponent,
    PercentageOffComponent,
    RawPriceComponent,
    RawPercentageOffComponent,
} = require('./ReducedPriceComponents');
const {
    Raw: RawReducedPriceTour,
    Connected: ReducedPriceTourConnected,
} = require('./ReducedPriceWithTour');

// Helpers
const provideContext = require('fluxible-addons-react/provideContext');
const connectToStores = require('fluxible-addons-react/connectToStores');
const classnames = require('classnames');
const {pageTypes} = require('dibs-buyer-layout/src/entries/index');

// Styles
const priceStyles = require('../Price/pdp-price.scss');
const styles = require('./styles.scss');

class ReducedPrice extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOnNewLine: false,
        };

        this._getWidthComparison = this._getWidthComparison.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this._getWidthComparison);
    }

    componentWillReceiveProps() {
        if (this._rightElement && !this._rightWidth) {
            this._rightWidth = this._rightElement.childNodes[0].getBoundingClientRect().width;
            this._getWidthComparison();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this._getWidthComparison);
    }

    _getWidthComparison() {
        const wrapperWidth = this._wrapperElement.getBoundingClientRect().width;
        const leftWidth = this._leftElement.getBoundingClientRect().width;
        const auxiliarySpacing = 25;

        if (wrapperWidth <= 0 && !this._rightWidth) {
            return false;
        }

        const isOnNewLine = this._rightWidth + leftWidth + auxiliarySpacing > wrapperWidth;

        this.setState({ isOnNewLine });
        return true;
    }

    render() {
        const {
            context,
            pageType,
            currencyLoaded = false,
            retailPrice,
            netPrice,
            salePrice,
            showPercentage,
            priceDisplays,
            showTour,
        } = this.props;
        const isPdp = pageType === pageTypes.PAGE_TYPE.PDP;
        let canShowPercentage = showPercentage;

        // If we don't show the list/retail price, then we don't show the percentage off
        if (!priceDisplays.showRetailPrice) {
            canShowPercentage = false;
        }

        // avoids flash of currency changing
        if (!currencyLoaded) {
            return false;
        }

        const wrapperClasses = classnames('is-net-price ', 'notranslate', 'cf', styles.isNetPrice, {
            'pdp-price': isPdp,
            [styles.price]: isPdp,
            'is-price-breaking': this.state.isOnNewLine,
            [priceStyles.portfolio]: pageType === pageTypes.PAGE_TYPE.FAVORITES, // favorites is synonymous to portfolio
        });

        let NetPriceComponent = null;
        let netPriceType = priceDisplays.showSalePrice ? 'sale' : 'net';
        if (showTour) {
            // Only PDP pages use NetPriceTour component connected to stores as itemStore can't be populated with multiple items required for favorites/cart.
            NetPriceComponent = isPdp ? (
                <ReducedPriceTourConnected type={netPriceType} context={context} />
            ) : (
                <RawReducedPriceTour {...this.props} type={netPriceType} />
            );
        } else if (priceDisplays.showSalePrice && salePrice) {
            NetPriceComponent = isPdp ? (
                <PriceComponent context={context} type="sale" />
            ) : (
                <RawPriceComponent {...this.props} type="sale" />
            );
        } else if (netPrice || priceDisplays.showRequestNetPrice) {
            // Only PDP pages use Price component connected to stores as itemStore can't be populated with multiple items required for favorites/cart.
            NetPriceComponent = isPdp ? (
                <PriceComponent context={context} type="net" />
            ) : (
                <RawPriceComponent {...this.props} type="net" />
            );
        }

        let RetailPriceComponent = null;
        if (priceDisplays.showRetailPrice && retailPrice) {
            // do not show retail price if it is a PUR item
            RetailPriceComponent =
                // Only PDP pages use Price component connected to stores as itemStore can't be populated with multiple items required for favorites/cart.
                isPdp ? (
                    <PriceComponent context={context} type="retail" />
                ) : (
                    <RawPriceComponent {...this.props} type="retail" />
                );
        }

        let PercentOff = null;
        const percentOffType = priceDisplays.showSalePrice ? 'sale' : 'net';
        // Only PDP pages show percentage off
        if (canShowPercentage && pageType !== pageTypes.PAGE_TYPE.FAVORITES) {
            PercentOff = (
                <span
                    ref={rightElement => {
                        this._rightElement = rightElement;
                    }}
                >
                    {isPdp ? (
                        <PercentageOffComponent context={context} type={percentOffType} />
                    ) : (
                        <RawPercentageOffComponent {...this.props} />
                    )}
                </span>
            );
        }

        return (
            <div
                className={wrapperClasses}
                data-tn="pdp-net-price-wrapper"
                ref={wrapperElement => {
                    this._wrapperElement = wrapperElement;
                }}
            >
                <div className={styles.retailPrice}>
                    <span
                        ref={leftElement => {
                            this._leftElement = leftElement;
                        }}
                    >
                        {RetailPriceComponent}
                    </span>
                    {PercentOff}
                </div>

                {NetPriceComponent}
            </div>
        );
    }
}

ReducedPrice.defaultProps = {
    showPercentage: true,
    showTour: false,
};

ReducedPrice.propTypes = {
    context: PropTypes.object,
    priceDisplays: PropTypes.object.isRequired,
    currencyLoaded: PropTypes.bool,
    retailPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    netPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    salePrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    showPercentage: PropTypes.bool,
    pageType: PropTypes.string,
    float: PropTypes.bool,
    showTour: PropTypes.bool,
};

const Connected = provideContext(
    connectToStores(ReducedPrice, [ItemStore, PriceStore, UserStore], context => {
        const userStore = context.getStore(UserStore);
        const itemStore = context.getStore(ItemStore);
        const priceStore = context.getStore(PriceStore);
        const item = itemStore.getItem();
        const processedPriceData = priceStore.processPrice(item);
        const {
            salePriceData = {},
            originalPriceData = {},
            netPriceData = {},
            retailPriceData = {},
        } = processedPriceData;
        return {
            currencyLoaded: userStore.isCurrencyLoaded(),
            netPrice: netPriceData.price,
            originalPrice: originalPriceData.price,
            priceDisplays: processedPriceData.priceDisplays,
            retailPrice: retailPriceData.price,
            salePrice: salePriceData.price,
        };
    })
);

module.exports = {
    Connected,
    Raw: ReducedPrice,
};



// WEBPACK FOOTER //
// ./assets/js/components/ReducedPrice/ReducedPrice.jsx